<div class="meter-container">
    <meter min="0" max="4" low="1" high="3" optimum="4" [value]="passwordStrength"></meter>
</div>
<div class="strength-text">Password strength: <span class="strength-label">{{passwordStrengthText}}</span></div>
<p class="password-warning" *ngIf="passwordWarning">{{passwordWarning}}</p>
